import {
    STORE_PROFILE,
    RESET_PROFILE,
    STORE_PLAYER_ID
} from './types';

export const storeProfile = profile => dispatch => {
    dispatch({ type: STORE_PROFILE, payload: profile });
}

export const resetProfile = () => dispatch => {
    dispatch({ type: RESET_PROFILE });
}

export const storePlayerId = playerId => dispatch => {
    dispatch({ type: STORE_PLAYER_ID,  payload: playerId });
}
